"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnterZoneScheduler = /** @class */ (function () {
    function EnterZoneScheduler(zone, scheduler) {
        this.zone = zone;
        this.scheduler = scheduler;
    }
    EnterZoneScheduler.prototype.schedule = function (work, delay, state) {
        var _this = this;
        if (delay === void 0) { delay = 0; }
        return this.zone.run(function () {
            return _this.scheduler.schedule.apply(_this.scheduler, [work, delay, state]);
        });
    };
    EnterZoneScheduler.prototype.now = function () {
        return this.scheduler.now();
    };
    return EnterZoneScheduler;
}());
exports.EnterZoneScheduler = EnterZoneScheduler;
function enterZone(zone, scheduler) {
    return new EnterZoneScheduler(zone, scheduler);
}
exports.enterZone = enterZone;
//# sourceMappingURL=enter-zone.sheduler.js.map